import { useEffect, useState } from 'react';
import {
  GroupChatTypeButton,
  GroupChatTypeContainer,
  GroupChatTypeWrapper,
} from '~/pages/Main/index.styled';
import GroupChatItem from '~/components/Main/GroupChatSection/GroupChatItem/GroupChatItem';
import {
  GroupChatType,
  GroupChatTypeArray,
} from '~/components/Main/GroupChatSection/GroupChatSection';
import { FlexStack } from '~/components/atomic';
import { GroupChatCard } from '~/components/atomic/Skeleton';
import { useGetGroupChatListQuery } from '~/features/chatRoom';
import { useIntersectionObserver } from '~/hooks';
import { makeIndexArray } from '~/utils';
import { HeaderWrapper, SubLength, Title } from './SearchResults';

interface GroupListResultsProps {
  query: string;
}

export default function GroupListResults({ query }: GroupListResultsProps) {
  const [groupChatType, setGroupChatType] = useState<GroupChatType>('all');

  const {
    data: groupChatData,
    isFetchingNextPage,
    fetchNextPage,
  } = useGetGroupChatListQuery({
    query,
    type: groupChatType,
  });

  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
  });
  useEffect(() => {
    if (isIntersecting) {
      fetchNextPage();
    }
  }, [isIntersecting]);

  return (
    <>
      <FlexStack>
        <HeaderWrapper>
          <Title>Group Chat</Title>
          <SubLength>{groupChatData.total} result</SubLength>
        </HeaderWrapper>

        <FlexStack>
          <GroupChatTypeContainer>
            <GroupChatTypeWrapper>
              {GroupChatTypeArray.map((type) => (
                <GroupChatTypeButton
                  key={type}
                  selected={groupChatType === type}
                  onClick={() => setGroupChatType(type)}
                >
                  {type}
                </GroupChatTypeButton>
              ))}
            </GroupChatTypeWrapper>
          </GroupChatTypeContainer>

          <FlexStack>
            {groupChatData.pages.map(
              ({
                id,
                name,
                description,
                language,
                participants_num,
                max_participants_num,
                room_type,
                characters,
              }) => (
                <GroupChatItem
                  key={id}
                  id={id}
                  chatTitle={name}
                  description={description}
                  language={language}
                  total={max_participants_num}
                  count={participants_num}
                  characters={characters}
                  type={room_type}
                />
              ),
            )}
          </FlexStack>

          {isFetchingNextPage ? (
            <FlexStack>
              {makeIndexArray(3).map((el) => (
                <GroupChatCard key={el} />
              ))}
            </FlexStack>
          ) : (
            <div ref={ref} />
          )}
        </FlexStack>
      </FlexStack>
    </>
  );
}
